import { makeStyles } from '@material-ui/core';
import { colors, fonts } from '../../shared/styles';

export const useStyles = makeStyles(() => ({
  profileInfoContainer: ({ isWithLaurel }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: '8px',
    paddingTop: isWithLaurel ? '4px' : 0
  }),
  profileInfoDivider: {
    backgroundColor: colors.grey,
    height: '12px',
    width: '1px',
  },
  profileInfoText: {
    color: colors.grey,
    fontFamily: fonts.default.fontFamily,
    fontSize: '14px',
    lineHeight: '20px',
  },
  profileLocation: {
    fontSize: 14,
    color: colors.grey,
    maxWidth: 250,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}))

export const styles = {
  profileColumn: {
    minWidth: 0, // to allow text to be truncated
  },
  profileCell: {
    display: 'flex',
    alignItems: 'center'
  },
  profilePhotoContainer: {
    display: 'inline-block',
    marginRight: 30,
    width: 48
  },
  profileNameContainer: (isMobile) => ({
    flex: '1 1 auto',
    verticalAlign: 'top',
    width: isMobile ? 160 : 334,
    position: 'relative'
  }),
  profileNameLink: (isMobile) => ({
    display: 'block',
    fontSize: isMobile ? 18 : 21,
    lineHeight: '1.2em',
    color: colors.textColor,
    textDecoration: 'none',
    width: isMobile ? 160 : 334,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: 'ProximaNovaBold'
  }),
  goalsQuote: {
    fontSize: 14,
    color: colors.grey,
    marginTop: 5,
    lineHeight: '20px'
  }
};
